const ResumeApi = [
  {
    id: 4,
    category: 'experience',
    year: 'Self-employed (2021 - present)',
    title: 'Full-stack web devloper - ',
    desc: 'Devloped many full-stack web application using React, Redux, Ruby on Rails, and PostgreSQL. ',
    rate: ' ',
  },
  {
    id: 2,
    category: 'education',
    year: 'Microverse (2022 - 2022)',
    title: 'Full-stack web devlopment',
    desc: 'Courses I took:- Ruby, Ruby on Rails, JavaScript, React, Redux, HTML, CSS, SQL, Git, GitHub, Heroku, Netlify, VSCode, Webpack, Jest, RSpec, Capybara, Selenium, Bootstrap, Pair Programming, OOP, TDD, RESTful API, Microverse curriculum, and more.',
    rate: '',
  },
];

export default ResumeApi;
